import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IProductReviewsAggregate, IReviewsAggregate } from "./reviewsAggregate";
import { IReviewWidgetAggregatePanel, ReviewWidgetAggregatePanel } from "./reviewWidgetAggregatePanel";
import { IReviewWidgetPager, ReviewWidgetPager } from "./reviewWidgetPager";

export interface IReviewWidgetBase extends IInstanceComponentBase {
    reviewWidgetPager: IReviewWidgetPager;
    update:(reviewsAggregate: IReviewsAggregate, newReviews: string, clearReviews: boolean) => void;
}

export abstract class ReviewWidgetBase extends InstanceComponentBase implements IReviewWidgetBase {
    public abstract reviewsAggregate: IReviewsAggregate;
    public reviewWidgetPager: IReviewWidgetPager;
    public abstract reviewWidgetAggregatePanel: IReviewWidgetAggregatePanel;
    
    constructor(public htmlElement: Element) {
        super(htmlElement);

        this.createReviewWidgetPager();
    }

    createReviewWidgetPager():void{
            let reviewWidgetPagerElement: HTMLElement | null = this.getHtmlElementForReviewWidgetPager();
            if (reviewWidgetPagerElement) {
                this.reviewWidgetPager = new ReviewWidgetPager(reviewWidgetPagerElement);
            }
        }

    getHtmlElementForReviewWidgetPager():HTMLElement{
        let reviewWidgetPagerElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewComponents.reviewWidgetPager))
        return reviewWidgetPagerElement;
    }

    abstract update(reviewsAggregate: IReviewsAggregate, newReviews: string, clearReviews: boolean): void;

    dispose() {
        
    }
}